<template>
  <v-container
    ref="container"
    fluid
    class="pa-0"
  >
    <v-row no-gutters>
      <v-col class="pa-0">
        <v-card class="pa-7">
          <v-row class="ma-0">
            <v-col
              xl="4"
              cols="3"
              lg="4"
              class="d-flex justify-center pt-2"
            >
              <img
                class="custom-position"
                :src="image_url"
              >
            </v-col>
            <v-col
              class="py-2 px-0"
              xl="7"
              lg="7"
              cols="8"
            >
              <v-skeleton-loader
                v-if="loading"
                class="mt-n4"
                type="list-item-three-line"
              />
              <div v-else class="headline wrap-word font-weight-bold fill-height">
                {{ name }}
                <br>
                <a
                  class="subtitle-2 word-break text-ellipsis"
                  :href="'mailto:' + email"
                >
                  {{ email }}
                </a>
                <div v-if="baseUrl.includes('app')">
                  <div
                    v-if="showPhone"
                    :class="fax.length === 0 ? 'subtitle-2 mt-1' : 'caption'"
                  >
                    <v-icon
                      v-if="fax.length !== 0"
                      small
                      color="mpBlue"
                    >mdi-phone</v-icon> {{ phone }}
                  </div>
                  <div
                    v-if="showFax && fax.length > 0"
                    class="caption"
                  >
                    <v-icon
                      small
                      color="mpBlue"
                    >mdi-fax</v-icon> {{ fax }}
                  </div>
                </div>
              </div>
            </v-col>
            <v-col
              class="d-flex justify-end pa-0"
              cols="1"
            >
              <v-menu
                v-if="!contactInfo.pseudonymized"
                attach
                dense
                offset-y
                left
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="grey"
                    class="text--darken-2"
                    v-track="'contact-actions-btn'"
                    icon
                    @click.stop
                    v-on="on"
                  >
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item
                    dense
                    @click="openEdit"
                    v-track="'edit-contact-fields-click'"
                  >
                    <v-icon class="mr-3 title">
                      mdi-pencil
                    </v-icon>
                    <v-list-item-title
                      class="font-weight-regular"
                    >
                      Edit Contact Fields
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    dense
                    @click="showDeletePrompt=true"
                    v-track="'delete-contact-click'"
                  >
                    <v-icon class="title mr-3">
                      mdi-delete
                    </v-icon><v-list-item-title class="font-weight-regular">
                      Delete Contact
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>
          <v-skeleton-loader
            v-if="loading"
            type="table-heading@6"
          />
          <div v-else>
          <v-row v-if="contactInfo.company" class="ma-0">
            <v-col cols="4" class="py-2 px-0 body-2 grey--text">
              Company
            </v-col>
            <v-col cols="8" class="pb-2 pt-1 d-flex align-center px-0">
              {{ contactInfo.company | upperCaseFirst }}
            </v-col>
          </v-row>
          <v-row v-if="contactInfo.billing_address !== ''" class="ma-0">
            <v-col cols="4" class="py-2 px-0 body-2 grey--text">
              BILLING ADDRESS
            </v-col>
            <v-col cols="8" class="pb-2 pt-1 d-flex align-center px-0">
              {{ contactInfo.billing_address }}
            </v-col>
          </v-row>
          <v-row v-if="contactInfo.shipping_address !== ''" class="ma-0">
            <v-col cols="4" class="py-2 px-0 body-2 grey--text">
              SHIPPING ADDRESS
            </v-col>
            <v-col cols="8" class="pb-2 pt-1 d-flex align-center px-0">
              {{ contactInfo.shipping_address }}
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col cols="4" class="py-2 px-0 body-2 grey--text">
              CUSTOMER CREATED
            </v-col>
            <v-col cols="8" class="pb-2 pt-1 d-flex align-center px-0">
              {{ $options.filters.formatDateTZ(createdAt,'DD MMMM YYYY') }}
            </v-col>
          </v-row>
        </div>
          <v-divider class="mt-4" />
          <v-container fluid>
            <v-list
              class="pt-0 pb-2 overflow-auto"
              max-height="356px"
            >
              <v-list-item
                v-for="item in visibleFields"
                :key="item[0]"
                :style="(item[1] || item[1] === false || item[1] === 0)?'':'display:none'"
                class="pa-0"
              >
                <v-list-item-content
                  v-if="item[1] || (item[1] === false || item[1] === 0)"
                  class="pa-0 mt-3"
                >
                  <v-row class="ma-0">
                    <v-col cols="4" class="py-2 px-0 body-2 text-uppercase grey--text">
                      {{ item[0].replace(/_/g, ' ') }}
                    </v-col>
                    <v-col cols="8" class="pb-2 pt-1 d-flex align-center px-0">
                      <div
                        v-if="typeOfCustomFields[(item[0])] !== 'datetime'"
                        class="body-2"
                      >
                        {{ item[1] }}
                      </div>
                      <div
                        v-else
                        class="body-2"
                      >
                        {{ manageESTDate(item[1]) }}
                      </div>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="showDeletePrompt" max-width="500">
      <v-card class="pa-4">
        <v-card-title class="text-h6 font-weight-medium-custom">
          <span class="secondary--font text-capitalize"> Delete Contact </span>
        </v-card-title>
        <v-card-text class="body-2">
          <p>
            You have selected this Contact to be deleted.
            Do you wish to continue deleting this Contact?
          </p>

          <b class="pt-10"> Warning: You cannot undo this action. </b>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showDeletePrompt = false" 
            class="font-weight-bold"
            v-track="'cancel-delete-contact-btn'">
            Cancel
          </v-btn>
          <v-btn dark @click="deleteContact()" :loading="deleteLoader" 
            class="font-weight-bold"
            v-track="'delete-contact'">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import config from "@core/config/app.config.js";
  import { $marketingContacts } from "@core/services"
  import { mapGetters } from "vuex"
  import moment from 'moment-timezone'
  export default {
    props: {
      contactId: [Number, String],
      listId: [Number, String],
    },
    data () {
      return {
        baseUrl: '',
        editRecord: false,
        deleteContactName: '',
        typeOfCustomFields: [],
        showSnackbar: { value: null, type: '' },
        showDeletePrompt: false,
        loading: false,
        visibleFields: [],
        name: '',
        email: '',
        phone: '',
        fax: '',
        createdAt: '',
        showPhone: true,
        showFax: true,
        contactInfo: {},
        config: config,
        deleteLoader: false,
      }
    },
    computed: {
      ...mapGetters({
        account: 'auth/account'
      }),
      image_url(){
        return require(`../../../assets/images/avatar/${this.contactId%10}.png`)
      }
    },
    watch: {
      '$store.state.ui.drawer.right.response': function () {
        if (this.$store.getters['ui/drawer'].right.response.checkUpdateInfo) {
          this.fetchCustomerInfo()
        }
      },
    },
    mounted () {
      if(this.$route.query.open_edit){
        this.openEdit()
      }
      this.fetchCustomerInfo()
      this.baseUrl = this.config.RAILS_BASE_URL     
    },
    methods: {
      manageESTDate(date){
        let abbr = moment.utc(date)
                .tz("America/New_York")
                .format('z');
        return this.$options.filters.formatDate(date) + " " + abbr;
      },
      openEdit () {
        this.$store.commit('ui/drawer.right', {
          show: true,
          component: 'contact-info-drawer',
          response: {
            checkUpdateInfo: false,
          },
        })
      },
      deleteContact () {
        this.deleteLoader = true
        $marketingContacts.delete(this.$route.params.contactId).then(response => {
          this.$store.commit('ui/snackbar', { message: response.data.data, type: 'success', timeout: 3000 })
          setTimeout(() => { this.$router.push(`/accounts/${this.account.id}/lists`) }, 3000)
        }).finally(() => {
          this.deleteLoader = false
          this.showDeletePrompt = false
        })
      },
      fetchCustomerInfo () {
        this.loading = true
        $marketingContacts.getFieldsData(this.$route.params.contactId).then(response => {
          this.typeOfCustomFields = response.data.data.fields_type
          this.deleteContactName = response.data.data.contact.email          
          const fieldsObj = response.data.data; this.visibleFields = []
          const selectedFields = JSON.parse(fieldsObj.selected_fields) || []
          this.createdAt = fieldsObj.contact.created_at
          
          if(selectedFields.includes('phone')){
            this.phone = (selectedFields.includes('phone') ? (fieldsObj.contact.phone) ? fieldsObj.contact.phone : fieldsObj.contact.custom_fields['phone'] : '')
          } else {
            this.phone = (selectedFields.includes('phone_number') ? fieldsObj.contact.custom_fields['phone_number'] : '')
          }
          this.fax = selectedFields.includes('fax') ? (fieldsObj.contact.fax || '') : ''
          this.showPhone = selectedFields.includes('phone') ? true : false
          this.showFax = selectedFields.includes('fax') ? true : false
          this.name = (selectedFields.includes('first_name') ? (fieldsObj.contact.first_name || '') : '') + ' ' + (selectedFields.includes('last_name') ? (fieldsObj.contact.last_name || '') : '')
          this.email = response.data.data.contact.email

          if(selectedFields.includes('company')){
            this.contactInfo.company = (selectedFields.includes('company') ? fieldsObj.contact.custom_fields['company'] : '')
          } else {
            this.contactInfo.company = (selectedFields.includes('company_name') ? fieldsObj.contact.custom_fields['company_name'] : '')
          }
          this.contactInfo.billing_address = (selectedFields.includes('billing_address') ? fieldsObj.contact.custom_fields['billing_address'] : '')
          this.contactInfo.shipping_address = (selectedFields.includes('shipping_address') ? fieldsObj.contact.custom_fields['shipping_address'] : '')
          const contactInformation = {
            id: this.$route.params.contactId,
            name: (fieldsObj.contact.first_name || '') + ' ' + (fieldsObj.contact.last_name || ''),
            email: this.email,
            phone: this.phone
          }
          this.$emit('getContactInfo', contactInformation )
          this.contactInfo.pseudonymized = fieldsObj.pseudonymized;
          if (selectedFields && selectedFields.length) {
            selectedFields.forEach((element) => {
              if (
                element === 'email' ||
                element === 'first_name' ||
                element === 'last_name' ||
                element === 'company' ||
                element === 'company_name' ||
                element === 'billing_address' ||
                element === 'shipping_address' ||
                element === 'created_at'
              ) {
                // Skipped case
              } else {
                this.visibleFields.push([element, fieldsObj.contact.custom_fields[element]])
              }
            })
          }
        }).catch((error) => {
          if(error.response.status === 404){
            this.$store.commit('ui/snackbar', { message: 'Contact not found.', type: 'error' })
            this.$router.push(`/accounts/${this.account.id}/lists`) 
          }
        }).finally(() => {
          this.loading = false
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
.v-card:hover .v-btn[on-hover-show] {
  display: flex !important;
}
.wrap-word{
  white-space: nowrap;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
}
.custom-position {
  max-width: 62px !important;
  max-height: 62px !important;
  height: 100%;
  border-radius: 50%;
  width: 100%;
}

.v-btn[on-hover-show] {
  display: none !important;
  position: absolute !important;
  top: 3%;
  right: 5%;
}
</style>
